module.exports = __webpack_public_path__ + "4263db8920ef2e4f61f9a4f856fbd3da.jpg";